/***
 * Copyright (c) Myia 2023-2025 - All Rights Reserved
 */

import { Blocks } from 'lucide-react';
import { Dispatch, FC, RefObject } from 'react';
import { v4 as uuid } from 'uuid';

import { CollapsibleSection } from './CollapsibleSection';
import { useHoverEffect } from './HoverEffect/HoverEffect';
import { LiveAgentSteps } from './LiveAgentSteps';
import { Story } from './LiveAgentTypes';

type BlockCardProps = {
    block: Story;
    dispatch: Dispatch<any>;
    closeModal: () => void;
};

export const LiveAgentBlockCard: FC<BlockCardProps> = ({ block, dispatch, closeModal }) => {
    const hoverEffectRef = useHoverEffect({
        scale: 1.02,
        duration: 0.1,
        shadow: true,
        shadowColor: '000',
        shadowOpacity: 0.1,
        modifier: 2,
    });

    return (
        <button
            onClick={() => {
                dispatch({
                    type: 'add',
                    payload: {
                        kind: 'block',
                        slug: block.slug,
                        name: block.name,
                        executed: false,
                        running: false,
                        blockSteps: block.steps.map((step) => {
                            return { ...step, executed: false, running: false, id: uuid() };
                        }),
                    },
                });
                closeModal();
            }}
            className="p-2 border overflow-hidden border-slate-300 flex flex-col gap-2 rounded text-start"
            ref={hoverEffectRef as RefObject<HTMLButtonElement>}
        >
            <div className="flex items-center gap-2 mb-auto">
                <Blocks className="shrink-0" />
                {block.name}
            </div>
            <div className="max-h-[15vh] w-full overflow-y-auto scrollbar-hide">
                <CollapsibleSection title="Steps" theme="small">
                    <LiveAgentSteps
                        steps={block.steps.map((step) => {
                            return { ...step, executed: true };
                        })}
                        inert
                        variables={{}}
                        precomputedVariables={{}}
                        editVariables={() => {}}
                    />
                </CollapsibleSection>
            </div>
        </button>
    );
};
